import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PlandayService } from '@fi-app/external-platform-integration/planday/planday.service';
import { ObjectTypes } from '@fi-shared/types';
import { IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { IPlandayImportLogListParameter } from '@fi-app/external-platform-integration/planday/planday';

@Component({
    selector: 'planday-import-log',
    templateUrl: './planday-import-log.component.html',
    styleUrls: ['./planday-import-log.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'planday-import-log' },
    standalone: false,
})
export class PlandayImportLogComponent implements OnInit {
    constructor(private plandayService: PlandayService) {}

    ngOnInit(): void {
        let itemsListParameter: IPlandayImportLogListParameter = {
            ObjectType: ObjectTypes.User,
        };
        this.plandayService.getImportLogListData(itemsListParameter).then((result) => {});
        itemsListParameter.ObjectType = ObjectTypes.BusinessUnit;
        this.plandayService.getImportLogListData(itemsListParameter).then((result) => {});
    }
}
